export enum CarpetType {
    Pattern = 0,
    RasterImage = 1,
    VectorImage = 2,
    Solid = 4,
}
